import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.82,4.342a.5.5,0,0,0-.32.466V9.627a.253.253,0,0,0,.108.206.249.249,0,0,0,.232.027L9.459,8.468A.842.842,0,0,0,10,7.679V3.088a.251.251,0,0,0-.109-.206.247.247,0,0,0-.231-.027Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.639,3.447a1,1,0,0,0,.722,0L8.906,2.074a.249.249,0,0,0,0-.465L5.3.179a.858.858,0,0,0-.613,0l-3.6,1.428a.249.249,0,0,0,0,.465Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.5,4.808a.5.5,0,0,0-.32-.466L.34,2.855A.25.25,0,0,0,0,3.089v4.59a.843.843,0,0,0,.542.79L4.16,9.86a.249.249,0,0,0,.232-.027A.253.253,0,0,0,4.5,9.627Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }